const formatMobile = mobile => {
  if (!mobile) return '';
  const newMobile = mobile.replace(/^\+?64/, '0');
  return newMobile.replace(/(\d{3})(\d{3})(\d)/, '$1 $2 $3');
};

export { formatMobile };
